<template>
  <div class="Container" v-if="UserProfile === 'SUP'">
    <h2 class="ViewHeading">Client User Admin</h2>

    <b-container>
      <h5 class="pageHeader">Select User Admin Action</h5>

      <div class="tab">
        <button
          v-if="selectedAction != 'AddClient'"
          class="reportTabLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add Client User
        </button>
        <button
          v-if="selectedAction == 'AddClient'"
          class="reportTabActiveLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add Client User
        </button>

        <button
          v-if="selectedAction != 'DeactClient'"
          class="reportTabRight"
          v-on:click="showModal('ClientDeactivateModal')"
        >
          Remove Client User
        </button>
        <button
          v-if="selectedAction == 'DeactClient'"
          class="reportTabActiveRight"
          v-on:click="selectedAction = 'DeactClient'"
        >
          Remove Client User
        </button>
      </div>

      <div class="tabcontent">
        <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
                <h3>Client User Add Form</h3>

                <b-row>
                  <b-col sm="3">
                    <p id="FormText">First Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="First Name"
                      v-model="fName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Last Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Last Name"
                      v-model="lName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Department</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Department"
                      v-model="clDept"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Company</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="clCompany">
                      <option value="" select disabled>Select Company</option>
                      <option
                        v-for="(value, id) in this.companyArray"
                        :key="id"
                        v-bind:value="{ id: value.id, text: value.name }"
                        >{{ value.name }}</option
                      >
                    </select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Email Address</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Email Address"
                      v-model="clEmail"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Location</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="clLocation">
                      <option value="" select disabled>Select Location</option>
                      <option
                        v-for="(value, id) in this.locationArray"
                        :key="id"
                        v-bind:value="{
                          id: value.id,
                          text: value.BuildingName,
                        }"
                        >{{ value.BuildingName }}</option
                      >
                    </select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <button
                      id="button"
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="AddNewClientAUTH0()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>

        <span class="SelectionRow" v-if="selectedAction == 'DeactClient'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'DeactClient'">
                <h3>Client User Inactivation Form</h3>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Name"
                      v-model="clientDeletion.Name"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Company</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Company"
                      v-model="clientDeletion.Company"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Location</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Location"
                      v-model="clientDeletion.BuildingName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Department</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Department"
                      v-model="clientDeletion.Department"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <button
                      id="button"
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="RemoveClient()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>
      </div>

      <!-------------------------------------------------------------------------------------------------------------------- 
-->
      <b-modal
        ref="ClientDeactivateModal"
        id="ClientDeactivateModal"
        hide-footer
        title=" Client Lookup Form"
        content-class="Modal"
      >
        <div>
          <h3>Search by user's name</h3>
          <input
            maxlength="45"
            type="text"
            v-model="UserFirstNameSearch"
            placeholder="First Name"
          />
          <input
            maxlength="45"
            type="text"
            v-model="UserSurnameSearch"
            placeholder="Last Name"
          />
          <br />
          <button
            id="button"
            class="button"
            v-on:click="LookUpSubmit('ClientDeactivate')"
          >
            Submit
          </button>
          <button class="button" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="ClientSelectionModal"
        id="ClientSelectionModal"
        hide-footer
        title="Client Selection Form"
        content-class="Modal"
      >
        <div>
          <h3>Select Client</h3>

          <select v-model="clientSelection">
            <option value="" select disabled>Select Installer</option>
            <option
              v-for="(value, id) in this.clientListArray"
              :key="id"
              v-bind:value="{
                UserURN: value.UserURN,
                Name: value.Name,
                Company: value.Company,
                BuildingName: value.BuildingName,
                Department: value.Department,
              }"
              >{{
                value.Name + " - " + value.Company + " - " + value.BuildingName
              }}</option
            >
          </select>

          <br />
          <button id="button" class="AdminButton" v-on:click="clientSelect()">
            Submit
          </button>
          <button class="AdminButton" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    btnCooldown: function() {
      let buttonid = "button";
      const button = document.querySelector("#" + buttonid + "");
      if (this.buttonCooldown == true) {
        const disableButton = () => {
          button.disabled = true;
        };
        button.addEventListener("click", disableButton);
      } else if (this.buttonCooldown == false) {
        button.disabled = false;
      }
    },
    showModal(Modal) {
      this.DivID = "";
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },
    resetForm() {
      this.DivID = "";
      (this.deactclURN = ""),
        (this.deactclFName = ""),
        (this.deactclLName = ""),
        (this.deactclDept = ""),
        (this.deactclLoc = ""),
        (this.fName = ""),
        (this.lName = "");
      this.clDept = "";
      this.clLocation = "";
      this.clEmail = "";
      this.DeviceRequestNo = "";
      this.messageforNewLocationEmail = "";
      this.clCompany = "";
      this.UserFirstNameSearch = "";
      this.UserSurnameSearch = "";
      this.selectedAction = "";
      this.clientDeletion = "";
    },

    clientSelect() {
      this.clientDeletion = this.clientSelection;
      this.hideModal("ClientSelectionModal");
      this.selectedAction = "DeactClient";
    },

    AddNewClientAUTH0() {
      this.buttonCooldown = true;

      if (
        this.clEmail == "" ||
        this.clLocation == "" ||
        this.fName == "" ||
        this.lName == "" ||
        this.clDept == ""
      ) {
        this.buttonCooldown = false;
        alert("Please ensure all fields are filled");
      } else {
        var randomNo1 = Math.floor(Math.random() * 9);
        var randomNo2 = Math.floor(Math.random() * 9);
        var randomNo3 = Math.floor(Math.random() * 9);
        var randomNo4 = Math.floor(Math.random() * 9);

        let totalNo = randomNo1.toString(10);
        totalNo = totalNo + randomNo2.toString(10);
        totalNo = totalNo + randomNo3.toString(10);
        totalNo = totalNo + randomNo4.toString(10);

        this.nickname = "";
        this.nickname = this.fName.slice(0, 3) + this.lName.slice(0, 3);
        this.nickname = this.nickname + totalNo;

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/auth0";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Create",
          Email: this.clEmail,
          UserMetaCompany: this.clCompany.text,
          UserMetaLocation: this.clLocation.text,
          AppMetaAccess: "CEUAll",
          AppMetaPortal: "CEU",
          FirstName: this.fName,
          LastName: this.lName,
          Name: this.fName + " " + this.lName,
          UserID: "",
          Username: this.nickname,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            this.buttonCooldown = false;

            this.clURN = response.data.Values.user_id;
            this.AddNewClientDB();
          });
      }
    },

    AddNewClientDB() {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Create",
        Type: "CEU",
        DataDict: [
          {
            UserURN: this.clURN,
            FirstName: this.fName,
            LastName: this.lName,
            Department: this.clDept,
            Company: this.clCompany.text,
            Location: this.clLocation.text,
            ConsentGiven: "FALSE",
          },
        ],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          this.HistoryNote = "Added Client";
          this.HistorySubmit();
          alert("Client has been created");
          this.resetForm();
        });
    },

    RemoveClient() {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Delete",
        Type: "CEU",
        DataDict: [{ UserURN: this.clientDeletion.UserURN }],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          this.HistorySubmit();
          alert("Client has been Inactivated");
          this.resetForm();
        });
    },

    HistorySubmit() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };

      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
          this.buttonCooldown = false;
        });
    },

    LookUpSubmit: function(Lookup) {
      this.buttonCooldown = true;

      if (Lookup === "ClientDeactivate") {
        let LookUpURLCl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/sulookups";
        let LookUpHeadersCl = this.$apikeyPost;
        let LookUpRequestCl = {
          RequestType: "ClientUser",
          RequestVariable: "",
          FirstName: this.UserFirstNameSearch,
          LastName: this.UserSurnameSearch,
        };

        axios
          .post(LookUpURLCl, LookUpRequestCl, LookUpHeadersCl)
          .then((response) => {
            this.buttonCooldown = false;

            if (response.data.Values == "Invalid Name") {
              this.buttonCooldown = false;

              alert("Please ensure the name entered is correct");
            } else if (response.data.Values[1] == null) {
              this.clientList = "";
              this.clientList = response.data.Values;
              this.clientSelection = [];
              this.clientDeletion = {};
              this.clientSelection.push({
                UserURN: this.clientList[0][0],
                Name: this.clientList[0][1],
                Company: this.clientList[0][2],
                BuildingName: this.clientList[0][3],
                Department: this.clientList[0][4],
              });
              this.clientDeletion = this.clientSelection[0];
              /*  this.deactInsURN = response.data.Values[0][0]
          this.deactInsFName = response.data.Values[0][1]
          this.deactInsLName = response.data.Values[0][2]
          this.deactInsEmail = response.data.Values[0][3]
          this.deactInsStatus = response.data.Values[0][5] */
              this.hideModal("ClientDeactivateModal");
              this.selectedAction = "DeactClient";
              this.UserFirstNameSearch = "";
              this.UserSurnameSearch = "";
            } else if (response.data.Values[1] != "") {
              this.clientList = "";
              this.clientList = response.data.Values;
              for (let i = 0; i < this.clientList.length; i++) {
                var QuoteStr1 = this.clientList[i][0];
                this.clientListArray.push({
                  UserURN: QuoteStr1,
                  Name: this.clientList[i][1],
                  Company: this.clientList[i][2],
                  BuildingName: this.clientList[i][3],
                  Department: this.clientList[i][4],
                });
              }
              this.hideModal("ClientDeactivateModal");
              this.showModal("ClientSelectionModal");
            }

            this.deactclURN = response.data.Values[0][0];
            this.deactclFName = response.data.Values[0][1];
            this.deactclLName = response.data.Values[0][2];
            this.deactclDept = response.data.Values[0][3];
            this.deactclLoc = response.data.Values[0][6];
            this.hideModal("ClientDeactivateModal");
            this.DivID = "Client Deactivate";
          });
      }

      if (Lookup === "EditLocation") {
        let LookUpURLEditLoc =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersEditLoc = this.$apikeyPost;
        let LookUpRequestEditLoc = {
          RequestType: "EscDetails",
          LocationDict: [
            { Location: this.contactLocation, Company: this.clCompany },
          ],
        };
        axios
          .post(LookUpURLEditLoc, LookUpRequestEditLoc, LookUpHeadersEditLoc)
          .then((response) => {
            this.buttonCooldown = false;

            this.editLocAddress = response.data.Values[0][0];
            this.editLocBuildingName = response.data.Values[0][1];
            this.editLocArea = response.data.Values[0][2];
            this.editLocEscName = response.data.Values[0][3];
            this.editLocEscEmail = response.data.Values[0][4];
            this.editLocEscTele = response.data.Values[0][5];

            this.DivID = "EditLoc";
          });
      }
    },

    filterLocations: function() {
      if (this.location.length == 0) {
        this.filteredlocations = this.locations;
      }
      this.filteredlocations = this.locations.filter((location) => {
        return location
          .toString()
          .toLowerCase()
          .startsWith(this.location.toString().toLowerCase());
      });
    },

    setLocation(location) {
      this.location = location;
      this.modal = false;
    },
  },

  mounted() {
    let UserAccessGroup = this.$ProfilePortal;
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }

    /* Company Lookup */
    let LookUpUrlCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersCompany = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Company" };
    axios
      .post(LookUpUrlCompany, this.LookUpRequest, LookUpHeadersCompany)
      .then((response) => {
        this.companylist = response.data.Values;
        for (let i = 0; i < this.companylist.length; i++) {
          var QuoteStr4 = this.companylist[i][0];
          this.companyArray.push({
            id: QuoteStr4,
            name: this.companylist[i][1],
          });
        }
      });

    /* Location Look Up */

    let LookUpUrlExistingLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingLocation = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Location", RequestVariable: "" };
    axios
      .post(
        LookUpUrlExistingLocation,
        this.LookUpRequest,
        LookUpHeadersExistingLocation
      )
      .then((response) => {
        this.locationList = response.data.Values;

        for (let i = 0; i < this.locationList.length; i++) {
          var QuoteStr4 = this.locationList[i][0];
          this.locationArray.push({
            id: QuoteStr4,
            Address: this.locationList[i][1],
            BuildingName: this.locationList[i][2],
            Country: this.locationList[i][3],
            Region: this.locationList[i][4],
            EscalationName: this.locationList[i][5],
            EscalationEmail: this.locationList[i][6],
            EscalationPhone: this.locationList[i][7],
            Company: this.locationList[i][8],
          });
        }
      });

    /* Existing Look Ups, remove at some point when they are no longer needed */

    let LookUpUrlLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/locations";
    let LookUpHeadersLocation = this.$apikeyPost;
    this.LookUpRequestLocation = {
      RequestType: "BMULocation",
      UserURN: this.UserURN,
    };
    axios
      .post(
        LookUpUrlLocation,
        this.LookUpRequestLocation,
        LookUpHeadersLocation
      )
      .then((response) => {
        this.locations = response.data.Values;
      });
    let LookUpUrlCountry =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersCountry = this.$apikeyPost;
    let LookUpRequestCountry = { RequestType: "CountryAll" };
    axios
      .post(LookUpUrlCountry, LookUpRequestCountry, LookUpHeadersCountry)
      .then((response) => {
        response;
        this.CountriesList = response.data.Values;
        for (let i = 0; i < this.CountriesList.length; i++) {
          var QuoteStr4 = this.CountriesList[i][0];
          this.CountriesArray.push({
            id: QuoteStr4,
            Country: this.CountriesList[i][1],
          });
        }
      });

    let LookUpUrlRegion =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersRegion = this.$apikeyPost;
    let LookUpRequestRegion = {
      RequestType: "RegionByCountry",
      CountryID: "5",
    };
    axios
      .post(LookUpUrlRegion, LookUpRequestRegion, LookUpHeadersRegion)
      .then((response) => {
        response;
        this.RegionsList = response.data.Values;
        for (let i = 0; i < this.RegionsList.length; i++) {
          var QuoteStr4 = this.RegionsList[i][0];
          this.RegionsArray.push({
            id: QuoteStr4,
            Region: this.RegionsList[i][1],
          });
        }
      });
  },

  data() {
    return {
      DivID: "",
      fName: "",
      lName: "",
      locationsArray: [],
      clCompany: "",
      clDept: "",
      clLocation: "",
      clEmail: "",
      clURN: "",
      UserFirstNameSearch: "",
      UserSurnameSearch: "",
      deactclURN: "",
      deactclFName: "",
      deactclLName: "",
      deactclDept: "",
      deactclLoc: "",
      locAddress: "",
      locTele: "",
      locEscEmail: "",
      locEscName: "",
      locFloor: "",
      locBuildingName: "",
      locArea: "",
      locations: "",
      location: "",
      filteredlocations: "",
      editLocAddress: "",
      editLocBuildingName: "",
      editLocArea: "",
      editLocEscName: "",
      editLocEscEmail: "",
      editLocEscTele: "",
      contactLocation: this.$Location,
      DeviceRequestNo: "",
      userName: this.$FullName,
      BMULocationRemove: "",
      UserURN: this.$UserURN,
      CountriesArray: [],
      RegionsArray: [],
      CountriesList: [],
      RegionsList: [],
      messageforNewLocationEmail: "",
      selectedSearch: "",
      UserProfile: this.$ProfilePortal,
      selectedAction: "",
      companyArray: [],
      companyList: [],
      locationArray: [],
      locationList: "",
      clientList: "",
      clientListArray: [],
      clientSelection: "",
      clientDeletion: "",
      buttonCooldown: false,
    };
  },

  watch: {
    location() {
      this.filterLocations();
    },
    buttonCooldown() {
      this.btnCooldown();
    },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="date"],
select {
  width: 100%;

  padding: 7px 7px 7px 7px;

  border: solid 1px rgba(200, 200, 200, 0.5);

  border-radius: 15px;

  background-color: rgb(245, 245, 245);
}

div {
  float: left;
  width: 100%;
  padding: 10px;
}

.container-fluid {
  border-style: none;
}

.card-body {
  border-style: none;
}

.collapse.show {
  border-style: none;
}

.container {
  border-style: none;
}

.row {
  border-style: none;
}
li {
  width: 100%;
}
input {
  margin-bottom: 8px;
}

input[type="number" i] {
  width: 30%;
}

.Auto {
  border: none;
  padding: none;
  margin: none;
}
.AutoDrop {
  width: 130%;
  text-align: left;
  float: right;
}

.locationAutoFill {
  border: none;
  padding: none;
  margin: none;
}

.locationAutoFillSpan {
  border: none;
  width: 50%;
  margin-left: 29%;
}

.locationAutoFillSpan li {
  background-color: whitesmoke;
}

.HandwashLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

.LocationHandwashAutoFillSpan {
  border: none;
  padding-left: 30%;
}

.LocationHandwashAutoFillSpan ul {
  width: 35%;
}

#AGPortalUser {
  margin-left: 10px;
}

.AutoDropDown {
  border: none;
  margin: none;
  padding: none;
}

.EditLocationAutoFillSpan {
  border: none;
}
.EditLocationAutoFillSpan ul {
  border: none;
  margin-left: 1%;
}

.EditLocationAutoFillSpan li {
  background: white;
}

.EditLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

#StaffRoleHide {
  border: none;
}
#LocationHide {
  border: none;
}

#DropdownAGRFIDRole {
  margin-left: 6px;
}

.lightText {
  text-align: center;
}

.LocationUnitAutoFillSpan {
  border: none;
}
.LocationUnitAutoFillSpan ul {
  border: none;
  margin-left: 10%;
}

.LocationUnitAutoFillSpan li {
  background: white;
}
.LocationDropdown {
  border: none;
}

#SubmitButtons {
  border: none;
  text-align: center;
}
.EditLocationDropdown input {
  margin-left: -5px;
}

#CenterButtons {
  text-align: center;
  border: none;
  padding: none;
  margin: none;
}

.tablinksActive {
  width: 25%;
}
.tablinks {
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
  width: 25%;
}

div.tab,
div.tabBottom {
  padding: 0;
}

.tablinksClientAdminActive {
  width: 50%;
}

.tablinksClientAdmin {
  width: 50%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

div.tabcontent {
  padding: 0;
}

.tablinksDeviceAdminActive {
  width: 25%;
}

.tablinksDeviceAdmin {
  width: 25%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 50%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 50%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 50%;
}

.reportTabActive {
  width: 50%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}
.AdminButton:hover {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
.AdminButton {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
</style>
